export const getCookie = (cookieName: string) => {
  const name = cookieName + '=';
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return null;
};

const getDomain = () =>
  window.location.origin.includes('ikea.com') ? '.ikea.com' : '.ikeadt.com';

export const setCookie = (
  cookieName: string,
  value: string,
  expireInDays: number = 30
) => {
  const [, country] = window.location.pathname.match(/\/(\w{2})\//) || [];

  const expirationDate = new Date();
  expirationDate.setTime(
    expirationDate.getTime() + expireInDays * 24 * 60 * 60 * 1000
  );
  const expires = 'expires=' + expirationDate.toUTCString();
  document.cookie = `${cookieName}=${value};${expires};domain=${getDomain()};path=/${country}/`;
};

export enum consentCategories {
  strictlyNecessaryCookies = 1,
  performanceCookies = 2,
  functionalCookies = 3,
  targetingCookies = 4,
  socialMediaCookies = 5,
  videoCookies = 'VID1',
}

export const checkConsent = (consent: consentCategories): boolean => {
  return window.ikea?.cookieConsent?.hasConsent(consent);
};
